import React from "react";
import Grid from "@material-ui/core/Grid";

import {
    Button,
    Typography,
} from "@material-ui/core";


import { useAppSelector, useAppDispatch } from '../../../app/hooks'
import { ExportMessgeraeteToExcel } from "../../../features/excelExport/ExportToExcel";
import {
    selectMessgeraete,
    selectMessgeraetetyp,
    selectEditEntry,
    startNewEntry,
    selectListLoading,
} from "./messgeraeteSlice";
import { useStyles } from "./messgeraeteStyles";
import { messgeraet, messgeraettyp } from "../../../utils/apiTypes";
import { globalStyles } from "../../../assets/globalStyles";
import { rollen, isAuthorized } from "../../../utils/auth/authConfig";

export const MessgeraeteActionheader: React.FC = () => {
    const dispatch = useAppDispatch();

    const classes = {
        ...useStyles(),
        ...globalStyles(),
    };

    const rows: messgeraet[] = useAppSelector(selectMessgeraete),
        messgeraettypSelectList: messgeraettyp[] = useAppSelector(selectMessgeraetetyp),
        editEntry: boolean = useAppSelector(selectEditEntry),
        listLoading: boolean = useAppSelector(selectListLoading);


    return (
        <Grid container spacing={2} style={{ marginBottom: "10px", padding: "0px", paddingLeft: "0px", paddingRight: "16px" }}>
            <Grid item md={3} >
                <Typography color="primary" variant="h6" className={classes.typoH6Style} style={{ marginLeft: "20px" }} >
                    Messgeräte Übersicht
                </Typography>
            </Grid>
            <Grid item md={3} />
            <Grid item md={3} />
            <Grid item md={3}>
                {isAuthorized([rollen.admin, rollen.betrieb]) ?
                    <Button
                        variant="contained"
                        onClick={() => {
                            dispatch(startNewEntry())

                        }}
                        color="secondary"
                        className={classes.showDuoButton}
                        disabled={editEntry}
                    >
                        Neues Messgerät
                    </Button>
                    : ""}
                <Button
                    variant="contained"
                    onClick={() => {
                        ExportMessgeraeteToExcel(rows.map(x => { return { msm: messgeraettypSelectList.find((mst: messgeraettyp) => mst.id == x.typ)?.hersteller, mstyp: messgeraettypSelectList.find((mst: messgeraettyp) => mst.id == x.typ)?.typ, ...x } }), "messgeraete")
                    }}
                    color="default"
                    className={classes.showDuoButton}
                    disabled={editEntry || listLoading}
                >
                    Export
                </Button>
            </Grid>
        </Grid>

    );
}
